import {
  TRANSFER_LOADING,
  GET_TRANSFER,
  GET_TRANSFER_SUCCESS,
  GET_TRANSFER_FAIL,
  ADD_TRANSFER_SUCCESS,
  ADD_TRANSFER_FAIL,
  DELETE_TRANSFER_SUCCESS,
  DELETE_TRANSFER_FAIL,
  UPDATE_TRANSFER_SUCCESS,
  UPDATE_TRANSFER_FAIL,
  TRANSFER_RESET
} from "./actionType";

const INIT_STATE = {
  transfers: [],
  error: {},
};

const Transfer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TRANSFER_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TRANSFER:
          return {
            ...state,
            transfers: action.payload.data,
            isTransferCreated: false,
            isTransferSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TRANSFER_FAIL:
      switch (action.payload.actionType) {
        case GET_TRANSFER_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTransferCreated: false,
            isTransferSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TRANSFER: {
      return {
        ...state,
        isTransferCreated: false,
        loading: true,
      };
    }

    case TRANSFER_LOADING: {
      return {
        ...state,
        isTransferCreated: false,
        loading: true,
      };
    }

    case ADD_TRANSFER_SUCCESS:
      return {
        ...state,
        isTransferCreated: true,
        loading: false,
        transfers: [action.payload.data, ...state.transfers],
      };

    case ADD_TRANSFER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TRANSFER_SUCCESS:
      return {
        ...state,
        loading: false,
        isTransferCreated: true,
        transfers: state.transfers.filter(
          transfer => transfer.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TRANSFER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TRANSFER_SUCCESS:
      return {
        ...state,
        loading: false,
        isTransferCreated: true,
        transfers: state.transfers.map(transfer =>
          transfer.id.toString() === action.payload.data.id.toString() ? { ...transfer, ...action.payload.data } : transfer
        ),
      };

    case UPDATE_TRANSFER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TRANSFER_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Transfer;